import React, { useState } from 'react';

import { Avatar, Flex, Space, Title } from '@mantine/core';
import { DashboardPageWrapper } from 'components/DashboardPageWrapper';
import { ShareSmartAssistantModal } from 'components/ShareSmartAssistantModal';
import { ManageSmartAssistantActions } from 'pages/ManageSmartAssistant/ManageSmartAssistantActions';
import { ManageSmartAssistantTabRouter } from 'pages/ManageSmartAssistant/ManageSmartAssistantTabRouter';
import { SmartAssistantPlaygroundDrawer } from 'pages/ManageSmartAssistant/Playground/SmartAssistantPlaygroundDrawer';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface ManageSmartAssistantPageProps {
  smartAssistant: SmartAssistant;
  avatarUrl?: string;
}

export function ManageSmartAssistantPage({ smartAssistant, avatarUrl }: ManageSmartAssistantPageProps) {
  const [shareSmartAssistantModalOpen, setShareSmartAssistantModalOpen] = useState(false);
  const closeShareSmartAssistantModal = () => setShareSmartAssistantModalOpen(false);
  const openShareSmartAssistantModal = () => setShareSmartAssistantModalOpen(true);

  const [playgroundDrawerOpen, setPlaygroundDrawerOpen] = useState(false);
  const closePlaygroundDrawer = () => setPlaygroundDrawerOpen(false);
  const openPlaygroundDrawer = () => setPlaygroundDrawerOpen(true);

  const smartAssistantAvatar = <Avatar size={30} radius={15} src={avatarUrl} />;

  return (
    <DashboardPageWrapper
      title={
        <Flex direction="row" align="center">
          {smartAssistantAvatar}
          <Space w="xs" />
          <Title order={4} truncate maw="50vw">
            {smartAssistant.name}
          </Title>
        </Flex>
      }
      rightComponent={
        <ManageSmartAssistantActions
          smartAssistant={smartAssistant}
          onShareClick={openShareSmartAssistantModal}
          onOpenPlaygroundClick={openPlaygroundDrawer}
        />
      }>
      <ManageSmartAssistantTabRouter smartAssistant={smartAssistant} smartAssistantAvatar={smartAssistantAvatar} />
      <ShareSmartAssistantModal
        smartAssistant={smartAssistant}
        opened={shareSmartAssistantModalOpen}
        onClose={closeShareSmartAssistantModal}
      />
      <SmartAssistantPlaygroundDrawer
        smartAssistant={smartAssistant}
        opened={playgroundDrawerOpen}
        onClose={closePlaygroundDrawer}
      />
    </DashboardPageWrapper>
  );
}
